import { closeAllMenus } from './utils';

const overlayClass = 'c-overlay';
const overlayActiveClass = overlayClass + '--active';

const overlayJsClass = 'js-overlay';

const overlayElement = document.querySelector('.' + overlayJsClass) as HTMLElement;

if (overlayElement) {
    // We close all the menus when clicking on the overlay
    overlayElement.addEventListener('click', () => {
        closeAllMenus();
    });
}

export function toggleOverlay (): void {
    if (!overlayElement) {
        return;
    }

    // If the overlay is active
    if (overlayElement.classList.contains(overlayActiveClass)) {
        // Hide overlay
        overlayElement.classList.remove(overlayActiveClass);
    } else {
        // Show overlay
        overlayElement.classList.add(overlayActiveClass);
    }
}

export function openOverlay (): void {
    if (!overlayElement) {
        return;
    }

    // If the overlay is not active
    if (!overlayElement.classList.contains(overlayActiveClass)) {
        // Show overlay
        overlayElement.classList.add(overlayActiveClass);
    }
}

export function closeOverlay (): void {
    if (!overlayElement) {
        return;
    }

    // If the overlay is active
    if (overlayElement.classList.contains(overlayActiveClass)) {
        // Hide overlay
        overlayElement.classList.remove(overlayActiveClass);
    }
}